const GOOGLE_FEEDBACK_MESSAGES = [
  {
    en: 'Rejection Reason: DESTINATION_URL_SITE_NOT_CRAWLABLE',
    ja:
      '遷移先URLに遷移できないため、却下されました。\n' +
      '遷移可能な場合、2, 3営業日以内に自動で再審査がかかります。',
  },
  {
    en: 'Rejection Reason: PHARMA_GAMBLING_ALCOHOL_NOT_ALLOWED',
    ja: 'ギャンブルやアルコールなどの広告のため却下されました。',
  },
  {
    en: 'Rejection Reason: ADULT_IMAGE_OR_VIDEO, Details: Adult Media Content',
    ja: 'アダルトコンテンツの広告のため却下されました。',
  },
  {
    en:
      'This creative is pending review by AdX but could potentially continue to serve while it is waiting',
    ja: '審査中です。',
  },
  {
    en: 'Rejection Reason: BROKEN_URL, Details: 404/Web Error on click through',
    ja: 'URLが破損しているため、却下されました。',
  },
  {
    en: 'Rejection Reason: LANDING_PAGE_DISABLED, Details: label: 301',
    ja: '遷移先URLからリダイレクトされるため、却下されました。',
  },
]

export const getGoogleFeedbackMessage = originalMessage => {
  return GOOGLE_FEEDBACK_MESSAGES.find(googleMessage =>
    originalMessage.includes(googleMessage.en),
  )
}
